<template>
  <div>
    <div class="row" v-if="leases == 0">
      <div class="col">
        <b-alert variant="primary p-5" show>
          <h4>Startup Guide</h4>
          <ul>
            <li>
              To get started:
              <ol>
                <li>
                    Create a
                    <router-link :to="{ name: 'tenants-create' }"
                      >tenant </router-link
                    > [Receivable]
                  </li>
                  <li>
                    Create a
                    <router-link :to="{ name: 'leases-create' }"
                      >lease</router-link
                    >
                    - which will link the tenant to the property.
                  </li>
                  <li>
                    Add your
                    <router-link
                      :to="{
                        name: 'companies-edit',
                        params: { id: company_id },
                      }"
                      >invoice details</router-link
                    >
                    - (logo, Banking)
                  </li>
                  <li>
                  Manage your <router-link
                    :to="{ name: 'contacts' }"
                    > contacts   (Suppliers, Providers, Creditors, Professionals)</router-link
                  > [Payable]
                  
                 
                </li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>Collection can be used to group units / properties.</li>
            <li>A unit / property can belong to multiple collections.</li>
            <li>A property is a single leasible unit</li>
            <li>Every flat in a building will be its own property</li>
            <li>
              Your first property &amp; first Email with 10mb disc space for
              free every month.
            </li>
          </ul>
        </b-alert>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <router-link
          :to="{ name: 'accounts-payments' }"
          class="btn btn-primary mt-1 w-50 border-right"
        >
          <i class="lni lni-money-location font-size-19"></i>
          <div class="py-1"><!-- --></div>
          Payments</router-link
        >

        <router-link
          :to="{ name: 'accounts-invoices' }"
          class="btn btn-primary mt-1 w-50 border-right"
        >
          <i class="lni lni-notepad font-size-19"></i>
          <div class="py-1"><!-- --></div>
          Invoices</router-link
        >

        <router-link
          :to="{ name: 'properties-create' }"
          class="btn btn-primary mt-1 w-50 border-right"
        >
          <i class="lni lni-plus font-size-19"></i>
          <div class="py-1"><!-- --></div>
          Property</router-link
        >

        <router-link
          :to="{ name: 'leases-create' }"
          class="btn btn-primary mt-1 w-50 border-right"
        >
          <i class="lni lni-plus font-size-19"></i>
          <div class="py-1"><!-- --></div>
          Lease</router-link
        >

        <vue-custom-scrollbar style="height: 800px" class="mt-3">
          <div class="card px-3 py-4 box-shadow">
            <h4 class="font-weight-500 mb-4">Notifcations</h4>

            <span v-for="n in notifications" :key="n.id">
              <div class="row border-bottom py-3">
                <div class="col-auto">
                  <b-avatar
                    :size="12"
                    :variant="notificationVariant(n.level)"
                    text="."
                  ></b-avatar>
                </div>
                <div class="col">
                  <p class="m-0 p-0">{{ n.message }}</p>
                  <small class="text-muted">
                    {{
                      moment(new Date(n.created_at)).format("DD MMM YY, HH:mm")
                    }}
                  </small>
                </div>
                <div class="col-auto">
                  <router-link
                    v-if="n.property_id"
                    :to="{
                      name: 'properties-show',
                      params: { id: n.property_id },
                    }"
                    variant="primary"
                    class="float-right no-round text-monospace font-size-13 px-2 py-1"
                    ><i class="lni lni-arrow-right"></i
                  ></router-link>
                </div>
              </div>
            </span>
          </div>
        </vue-custom-scrollbar>
      </div>

      <div class="col-md-8">
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ totalReceivable | currency }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-success">
                      <div class="circle-icon">
                        <i
                          class="lni lni-money-protection text-white font-size-26"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Accounts Receivable</p>
              </div>
            </div>
          </div>

        
          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ totalPayable | currency }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-danger">
                      <div class="circle-icon">
                        <i
                          class="lni lni-money-protection text-white font-size-26"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Accounts Payable</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ monthlyPaymentsIn | currency }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-success">
                      <div class="circle-icon">
                        <i class="lni lni-arrow-left-circle text-white font-size-26"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Monthly Payments Received</p>
              </div>
            </div>
          </div>

            <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ monthlyPaymentsOut | currency }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-warning">
                      <div class="circle-icon">
                        <i class="lni lni-arrow-right-circle text-white font-size-26"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Monthly Payments Out</p>
              </div>
            </div>
          </div>


          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ monthlyInvoiced | currency }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-warning">
                      <div class="circle-icon">
                        <i
                          class="lni lni-cart-full text-white font-size-26"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Invoiced this month</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ monthlyExpenses | currency }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-secondary">
                      <div class="circle-icon">
                        <i class="lni lni-drop text-white font-size-26"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Expenses this month</p>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3">
            <div class="card">
              <div class="card-body">
                <bar-chart
                  v-if="chartReady"
                  :chart-data="chartData"
                  :options="chartOptions"
                ></bar-chart>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ leases | currency }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-info">
                      <div class="circle-icon">
                        <i
                          class="lni lni-add-files text-white font-size-26"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Active Leases</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ propertiesOccupied }}
                      <small class="text-black-50 font-size-11">of</small>
                      {{ properties }}
                      <small class="text-black-50 font-size-11">occupied</small>
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-primary">
                      <div class="circle-icon">
                        <i
                          class="lni lni-apartment text-white font-size-26"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Properties</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col"></div>
    </div>

    <div class="row my-3">
      <div class="col-md-6">
        <div class="card box-shadow mb-3">
          <div class="card-body">
            <h4>Expiring Leases</h4>
            <p class="text-black-50" v-if="expiringLeases.length == 0">
              No upcoming expiring leases
            </p>

            <div
              v-for="lease in expiringLeases"
              :key="lease.id"
              class="border-bottom py-3 row"
            >
              <div class="col-4">
                <router-link
                  :to="{ name: 'leases-show', params: { id: lease.id } }"
                >
                  <i class="lni lni-user"></i> {{ lease.tenant.name }}
                </router-link>
              </div>
              <div class="col-4">
                <router-link
                  :to="{ name: 'leases-show', params: { id: lease.id } }"
                >
                  <i class="lni lni-apartment"></i>
                  {{ lease.property.title }}
                </router-link>
              </div>
              <div class="col-4 text-right">
                <i class="lni lni-calendar"></i>
                {{ moment(new Date(lease.to)).format("DD MMM YY") }}
              </div>
            </div>
          </div>
        </div>

        <div class="card box-shadow mb-3">
          <div class="card-body">
            <h4>Billing</h4>
            <p class="text-black-50">{{ moment().format("MMMM Y") }}</p>
            <div class="row mt-4">
              <div class="col-md-4">
                <h3 class="m-0 p-0">{{ properties }}</h3>
                <small class="text-muted">Properties</small>
              </div>
              <div class="col-md-4">
                <h3 class="m-0 p-0">{{ storageUsed.toFixed(2) }}</h3>
                <small class="text-muted">Storage (Mb)</small>
              </div>
              <div class="col-md-4">
                <h3 class="m-0 p-0">{{ emailsSent }}</h3>
                <small class="text-muted">Emails Sent</small>
              </div>

              <div class="col-12 mt-3 border-top pt-3">
                <h2 class="text-primary font-weight-bold text-monospace">
                  R{{ bill.toFixed(2) | currency }}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="leases > 0">
        <b-alert variant="info" class="p-5" show>
          <b-media>
            <template #aside>
              <i class="lni lni-bulb font-size-26"></i>
            </template>

            <h6>Usage Guide</h6>
            <ul class="font-size-13">
              <li>
                To get started:
                <ol>
                  <li>
                    Create a
                    <router-link :to="{ name: 'properties-create' }"
                      >property</router-link
                    >
                  </li>
                  <li>
                    Create a
                    <router-link :to="{ name: 'tenants-create' }"
                      >tenant </router-link
                    > [Receivable]
                  </li>
                  <li>
                    Create a
                    <router-link :to="{ name: 'leases-create' }"
                      >lease</router-link
                    >
                    - which will link the tenant to the property.
                  </li>
                  <li>
                    Add your
                    <router-link
                      :to="{
                        name: 'companies-edit',
                        params: { id: company_id },
                      }"
                      >invoice details</router-link
                    >
                    - (logo, Banking)
                  </li>
                  <li>
                  Manage your <router-link
                    :to="{ name: 'contacts' }"
                    > contacts   (Suppliers, Providers, Creditors, Professionals)</router-link
                  > [Payable]
                  
                 
                </li>
                </ol>
              </li>
            </ul>
            <ul class="font-size-13">
              <li>Collection can be used to group units / properties.</li>
              <li>A unit / property can belong to multiple collections.</li>
              <li>A property is a single leasible unit</li>
              <li>Every flat in a building will be its own property</li>
            </ul>
          </b-media>
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import homeRepo from "@/api/repos/homeRepo";
import vueCustomScrollbar from "vue-custom-scrollbar";
import BarChart from "../../components/charts/bar";

export default {
  components: {
    vueCustomScrollbar,
    BarChart,
  },
  data() {
    return {
      company_id: localStorage.getItem("current_company_id"),
      notifications: [],
      monthlyPaymentsIn: 0,
      monthlyPaymentsOut: 0,
      monthlyExpenses: 0,
      leases: 0,
      monthlyInvoiced: 0,
      totalPayable: 0,
      totalReceivable: 0,
      properties: 0,
      propertiesOccupied: 0,
      storageUsed: 0,
      emailsSent: 0,
      bill: 0,
      expiringLeases: [],
      chartReady: false,
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
              },
            },
          ],
        },
      },
    };
  },

  mounted() {
    this.getData();
    this.timer = setInterval(this.getData, 60000);
  },

  methods: {
    notificationVariant(level) {
      if (level == 1) {
        return "success";
      } else if (level == 2) {
        return "info";
      } else if (level == 3) {
        return "warning";
      } else {
        return "danger";
      }
    },
    async getData() {
      try {
        let { data } = await homeRepo.home();
        this.notifications = data.notifications;
        this.monthlyPaymentsIn = data.monthly_payments_in;
        this.monthlyPaymentsOut = data.monthly_payments_out;
        this.leases = data.leases;
        this.totalPayable= data.total_payable;
        this.totalReceivable=data.total_receivable
        this.monthlyInvoiced = data.monthly_invoiced;
        this.monthlyExpenses = data.monthly_expenses;
        this.properties = data.properties;
        this.propertiesOccupied = data.properties_occupied;
        this.expiringLeases = data.expiring_leases;
        this.storageUsed = data.storage_used;
        this.emailsSent = data.emails_sent;
        this.bill = data.bill;

        let tempChartData = {
          labels: ["2 Ago", "Previous", "Current Month"],
          datasets: [
            {
              backgroundColor: "rgb(255, 0, 0,0.5)",
              label: "invoices",
              data: [
                data.monthly_invoiced_third_month,
                data.monthly_invoiced_second_month,
                data.monthly_invoiced,
              ],
            },
            {
              backgroundColor: "rgb(0,255, 0,0.5)",
              label: "payments in",
              data: [
                data.monthly_payments_in_third_month,
                data.monthly_payments_in_second_month,
                data.monthly_payments_in,
              ],
            },
               {
              backgroundColor: "rgb(0,0, 128,0.3)",
              label: "payments out",
              data: [
                data.monthly_payments_out_third_month,
                data.monthly_payments_out_second_month,
                data.monthly_payments_out,
              ],
            },
            {
              backgroundColor: "rgb(255, 255, 0,0.5)",
              label: "expenses",
              data: [
                data.monthly_expenses_third_month,
                data.monthly_expenses_second_month,
                data.monthly_expenses,
              ],
            },
          ],
        };
        this.chartData = tempChartData;
        this.chartReady = true;
      } catch (e) {
        if (this.timer) clearInterval(this.timer);
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.timer) clearInterval(this.timer);
    next();
  },

  computed: {
    user() {
      return this.$store.state.user.user;
    },
    companies() {
      return this.$store.state.user.companies;
    },
    current_company_id() {
      return this.$store.state.user.current_company_id;
    },
    cc() {
      return this.companies.filter((c) => c.id == this.current_company_id)[0];
    },
  },
};
</script>

<style>
.circle-icon-con {
  height: 70px;
  width: 70px;
  border-radius: 35px;
  padding-top: 5px;
  color: white;
}
.circle-icon {
  height: 60px;
  width: 60px;
  border-radius: 30px;
  margin: auto;
  line-height: 60px;
  text-align: center;
  border: solid 5px white;
}
</style>
